import { EditComplaint } from "./edit-complaints";

export default EditComplaint;
